/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MemberStore from '../../stores/MemberStore';

const ReactPropTypes = PropTypes;
const webroot = get(globals, 'webroot', '/');

class MemberLink extends React.Component {
  state = {
    member: this.props.member || MemberStore.get(this.props.memberId),
  };

  render() {
    const { member } = this.state;
    const {
      customLink,
      disable,
      linkClass,
      children,
      memberId,
    } = this.props;

    // disable, empty, deleted vai admin
    if (disable || !member || ['deleted', 'admin'].indexOf(member.status) !== -1) {
      return (
        <a
          href="#top"
          className={linkClass}
        >
          {children}
        </a>
      );
    }
    let memberUrl = `${webroot}member/${memberId}`;

    if (customLink) {
      memberUrl = customLink;
    }

    return (
      <a
        href={memberUrl}
        data-target="#content"
        className={linkClass}
      >
        {children}
      </a>
    );
  }
}

MemberLink.propTypes = {
  member: PropTypes.shape({}),
  memberId: ReactPropTypes.string,
  disable: ReactPropTypes.bool,
  linkClass: ReactPropTypes.string,
  customLink: ReactPropTypes.string,
  // children: PropTypes.arrayOf(PropTypes.any),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.instanceOf(Object),
  ]),
};

MemberLink.defaultProps = {
  member: null,
  memberId: null,
  disable: false,
  linkClass: '',
  customLink: null,
  children: [],
};

module.exports = MemberLink;
